"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var RawHtmlEditConfig = {
  emptyLabel: 'Raw Html',
  isEmpty: function isEmpty(props) {
    if (typeof props.htmlSource !== 'undefined' && props.htmlSource) {
      return false;
    } else {
      return true;
    }
  }
};
var RawHtml = function RawHtml(_ref) {
  var _ref$htmlSource = _ref.htmlSource,
    htmlSource = _ref$htmlSource === void 0 ? '' : _ref$htmlSource,
    anchorId = _ref.anchorId;
  var divRef = (0, _react.useRef)(null);
  var _React$useState = _react.default.useState(null),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    renderedHtml = _React$useState2[0],
    setRenderedHtml = _React$useState2[1];
  (0, _react.useEffect)(function () {
    var div = document.createElement('div');
    div.innerHTML = htmlSource;
    var scriptChain = Promise.resolve();
    var addScriptsToDOM = function addScriptsToDOM() {
      Array.from(div.getElementsByTagName('script')).forEach(function (scriptTag) {
        var _scriptTag$parentNode;
        (_scriptTag$parentNode = scriptTag.parentNode) === null || _scriptTag$parentNode === void 0 ? void 0 : _scriptTag$parentNode.removeChild(scriptTag);
        scriptChain = scriptChain.then(function () {
          return new Promise(function (resolve) {
            var newScript = document.createElement('script');
            (0, _toConsumableArray2.default)(scriptTag.attributes).forEach(function (attr) {
              attr.nodeValue && newScript.setAttribute(attr.nodeName, attr.nodeValue);
            });
            newScript.innerHTML = scriptTag.innerHTML;
            if (newScript.src) newScript.onload = function () {
              return resolve();
            };else resolve();
            if (!divRef || !divRef.current) return;
            divRef.current.appendChild(newScript);
          });
        });
      });
    };
    // Regular expression to match "<script>" tag and variations
    var regex = /<script(?:\s[^>]*)?>/;
    // Check each string for the presence of "<script>" tag and variations
    var isScriptPresent = regex.test(htmlSource);
    var isNomographScript = htmlSource && (htmlSource.includes('jquery-ui-accordion-menu') || htmlSource.includes('calculator.js') || htmlSource.includes('nomograph'));
    var timer;
    if (isScriptPresent && isNomographScript) {
      timer = setTimeout(function () {
        addScriptsToDOM();
      }, 2000);
    } else {
      addScriptsToDOM();
    }
    setRenderedHtml(div.innerHTML);
    return function () {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [htmlSource]);
  return __jsx(_react.default.Fragment, null, __jsx("div", {
    id: anchorId,
    dangerouslySetInnerHTML: {
      __html: renderedHtml || ''
    }
  }), __jsx("div", {
    ref: divRef
  }));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/rawhtml')(RawHtml, RawHtmlEditConfig);
exports.default = _default;